module.exports = __webpack_public_path__ + "img/hospital-dois-pinheiros.d1fdee26.png";